import { useState } from 'react';
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import _ from 'lodash';
//components
import FormCreator from 'components/FormCreator';
import { setListOfInvalids } from 'components/FormCreator/validation';
import { fieldsGroupType, fieldType, invalidFields, validationTypes } from 'components/FormCreator/types';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { userFieldsValidations } from 'constants/settings.constants';
import UserEditCard from './UserEditCard';
import { changeUserData } from 'services/user.services';
import { API_UPDATE_CONTACT_EMAIL } from 'constants/db.constants';
import { FormInputsTypes } from 'constants/settings.constants';
import { validateFields } from 'components/FormCreator/validation';

export default function EditEmail({ handleCancelEdit }) {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const [currentEmail, setCurrentEmail] = useState('');
	const [newEmail, setNewEmail] = useState('');
	const [newEmailConfirm, setNewEmailConfirm] = useState('');
	const prefixFields = 'forms.settings.user_edit.';

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		updateInput(name, value);
		if (_.has(userFieldsValidations, name)) {
			setInvalidFields(setListOfInvalids(invalidFields, userFieldsValidations, name, value));
		}
	};

	const updateInput = (name, value) => {
		if (name === 'currentEmail') {
			setCurrentEmail(value);
		} else if (name === 'newEmail') {
			setNewEmail(value);
		} else {
			setNewEmailConfirm(value);
		}
	};

	const handleSaveCLick = () => {
		let obj = {
			['currentEmail']: currentEmail,
			['newEmail']: newEmail,
			['newEmailConfirm']: newEmailConfirm,
		};

		const invalidFields = validateFields(userFieldsValidations, obj);
		if (_.keys(invalidFields).length) {
			setInvalidFields(invalidFields);
		} else {
			const formData = new FormData();
			formData.append('currentEmail', String(currentEmail));
			formData.append('newEmail', String(newEmail));
			formData.append('newEmailConfirmation', String(newEmailConfirm));
			dispatch(
				changeUserData(
					{ currentEmail, newEmail, newEmailConfirm },
					formData,
					FormInputsTypes.EMAIL,
					API_UPDATE_CONTACT_EMAIL
				)
			);
		}
	};

	const [invalidFields, setInvalidFields] = useState<invalidFields>({});

	return (
		<UserEditCard
			handleSaveClick={handleSaveCLick}
			handleCancelEdit={handleCancelEdit}
			title={t('page.settings.form.title.user_email')}
			cancelButtonText={t('portal.actions.cancel')}
			saveButtonText={t('portal.actions.save')}
		>
			<FormCreator
				initialValidation={invalidFields}
				name="contactEmail"
				handleChange={handleChange}
				fieldsGroups={[
					{
						type: fieldsGroupType.col,
						fields: [
							{
								type: fieldType.text,
								validation: [validationTypes.requierd],
								props: {
									required: true,
									name: 'currentEmail',
									label: t(`${prefixFields}currentEmail`),
									placeholder: 'e.g. test@gmail.com',
									value: currentEmail,
								},
							},
							{
								type: fieldType.text,
								props: {
									required: true,
									name: 'newEmail',
									label: t(`${prefixFields}newEmail`),
									placeholder: 'e.g. test@gmail.com',
									value: newEmail,
								},
							},
							{
								type: fieldType.text,
								props: {
									required: true,
									name: 'newEmailConfirm',
									label: t(`${prefixFields}newEmailConfirm`),
									placeholder: 'e.g. test@gmail.com',
									value: newEmailConfirm,
								},
							},
						],
					},
				]}
			/>
		</UserEditCard>
	);
}
